import React from "react";
import Box from "@mui/material/Box/Box";
import Autocomplete from "@mui/material/Autocomplete/Autocomplete";
import Stack from "@mui/material/Stack/Stack";
import Typography from "@mui/material/Typography/Typography";
import TextField from "@mui/material/TextField/TextField";
import { ICountry, IOption } from "models/app";
import { countriesList } from "config";

interface Props {
  selectedCountry: ICountry;
  onChange: (value: ICountry) => void;
  disabled?: boolean;
  label?: string;
}

const SelectedCountryCode: React.FC<Props> = ({
  selectedCountry,
  onChange,
  disabled,label
}) => {
  let options: IOption[] = countriesList.map((country) => {
    const flagSrc = `https://flagsapi.com/${country.countryCode}/flat/32.png`;
    return {
      label: country.countryName,
      icon: (
        <Box
          component={"img"}
          alt={country.countryName}
          src={flagSrc}
          width={{ xs: 24, md: 34 }}
          height={{ xs: 24, md: 34 }}
        />
      ),
      value: country.phoneNumberCode,
    };
  });

  return (
    <>
      <Autocomplete
        multiple={false}
        limitTags={1}
        disabled={disabled}
        options={options}
        clearIcon={null}
   
        isOptionEqualToValue={(option: any, value) =>
          option.value === value?.value!
        }
        value={options.find(
          (a) => a.value === selectedCountry?.phoneNumberCode
        )}
        filterOptions={(options, state) => {
          if (state.inputValue?.length === 0) return options;
          return options.filter((option) =>
            option
              .label!.toLowerCase()
              .includes(state.inputValue!.toLowerCase())
          );
        }}
        onChange={(_, data) => {
          onChange(
            data
              ? countriesList.find(
                  (a: any) => a.phoneNumberCode === data.value
                )!
              : { phoneNumberCode: "", countryCode: "", countryName: "" }
          );
        }}
        getOptionLabel={(option: IOption) => option.label || ""}
        renderOption={(props, option: IOption) => (
          <li {...props}>
            <Stack direction="row" spacing={2} alignItems="end">
              {option.icon}
              <Typography variant="body2" fontWeight={300} textAlign="start">
                {option.label}
              </Typography>
            </Stack>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label={
              <Stack direction={"row"} mr={1}>
                {label}
              </Stack>
            }
            // helperText={errors[name] ? `${errors[name].message}` : helperText}
            size="small"
            required={true}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  {selectedCountry?.countryCode && (
                    <Box
                      component={"img"}
                      alt={selectedCountry?.countryCode}
                      src={`https://flagsapi.com/${selectedCountry?.countryCode!}/flat/32.png`}
                      width={24}
                      height={24}
                      mx={1}
                    />
                  )}
                </>
              ),
            }}
            InputLabelProps={{
              shrink: true,
              children: "Country Code",

              sx: {
                fontSize: "18px",
                mr: 1,
                "& .MuiInputLabel-asterisk": {
                  color:  selectedCountry?"#0009":'red' ,
                  marginTop:'-25px',
                  marginLeft:'140px',
                  fontSize: "24px",
                  display: "block",
                },
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                bgcolor: "common.white",
                width: "100%",
                padding: "0px !important",
              },
              "& .MuiInputBase-root": {
                fontFamily: "Cairo",
                width: "100%",
                borderRadius: "8px",
                border: "none",
                bgcolor: !disabled ? "common.white" : "#FFFFFF",
                fontSize: { xs: "14px", md: "16px" },
                height: "48px",
                padding: "5px !important",
              },
              // if disabled then change the color of the input
              "& .MuiInputBase-root.Mui-disabled": {
                bgcolor: "#f5f5f5",
              },
              // change title color
              "& .MuiFormLabel-root": {
                color: !disabled ? "text.main" : "text.disabled",
              },
              // value of input
              "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input ":
                {
                  width: { xs: "calc(100% - 50px)", lg: "calc(100% - 60px)" },
                  padding: "0px !important",
                },
            }}
          />
        )}
      />
    </>
  );
};

export default SelectedCountryCode;
